<template>
    <section>
        <a-col :span="24" :md="24" :lg="24" :xl="24" class="mb-0">
            <a-card 
                :loading="data.isLoading" 
                :bordered="false" 
                class="header-solid h-full" 
            >
                <!-- style="background-color:#ebeced;" -->
                <!-- <hr style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;"> -->
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10">{{ tinNo }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <img
                            v-if="data.tinUploadType == 'pdf'"
                            :size="74"
                            style="height: 70px; width: 70px;cursor: pointer"
                            shape="square"
                            src="/images/pdf-image.png"
                            @click.prevent="onPdfModalShow(tinUrl)"
                        />
                        <a-avatar
                            v-else
                            :size="74"
                            shape="square"
                            :src="tinUrl"
                            @click="onImageClick(tinUrl)"
                        />
                    </div>
                </div>

                <hr style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10">{{ binNo }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <img
                            v-if="data.binUploadType == 'pdf'"
                            :size="74"
                            style="height: 70px; width: 70px;cursor: pointer"
                            shape="square"
                            src="/images/pdf-image.png"
                            @click.prevent="onPdfModalShow(binUrl)"
                        />
                        <a-avatar
                            v-else
                            :size="74"
                            shape="square"
                            :src="binUrl"
                            @click="onImageClick(binUrl)"
                        />
                    </div>
                </div>

                <hr style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ tradeLicenseNo }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <img
                            v-if="data.tradeLicenseUploadType == 'pdf'"
                            :size="74"
                            style="height: 70px; width: 70px;cursor: pointer"
                            shape="square"
                            src="/images/pdf-image.png"
                            @click.prevent="onPdfModalShow(tradeLicenseUrl)"
                        />
                        <a-avatar
                            v-else
                            :size="74"
                            shape="square"
                            :src="tradeLicenseUrl"
                            @click="onImageClick(tradeLicenseUrl)"
                        />
                    </div>
                </div>

                <!-- <hr style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ realEstateMembershipNo }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <a-avatar
                            :size="74"
                            shape="square"
                            :src="realEstateMembershipUrl"
                            @click="onImageClick(realEstateMembershipUrl)"
                        />
                    </div>
                </div> -->

                <!-- <hr style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ landDevelopersMembershipNo }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <a-avatar
                            :size="74"
                            shape="square"
                            :src="landDevelopersMembershipUrl"
                            @click="onImageClick(landDevelopersMembershipUrl)"
                        />
                    </div>
                </div> -->

                <!-- <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.income-tax') }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <a-avatar
                            :size="74"
                            shape="square"
                            :src="incomeTaxUrl"
                            @click="onImageClick(incomeTaxUrl)"
                        />
                    </div>
                </div> -->

                <!-- v-if="data.ownership == 'PVT LTD'" -->
                <div >
                    <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                    <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                        <div class="ant-col" style="padding: 12px;">
                            <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.incorporation-certificate-url-is') }}</h6>
                        </div>
                        <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                            <img
                                v-if="data.incorporationCertificateUploadType == 'pdf'"
                                :size="74"
                                style="height: 70px; width: 70px;cursor: pointer"
                                shape="square"
                                src="/images/pdf-image.png"
                                @click.prevent="onPdfModalShow(incorporationCertificateUrl)"
                            />
                            <a-avatar
                                v-else
                                :size="74"
                                shape="square"
                                :src="incorporationCertificateUrl"
                                @click="onImageClick(incorporationCertificateUrl)"
                            />
                        </div>
                    </div>
                    <!-- <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                    <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                        <div class="ant-col" style="padding: 12px;">
                            <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.memorandum-association') }}</h6>
                        </div>
                        <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                            <a-avatar
                                :size="74"
                                shape="square"
                                :src="memorandumAssociationUrl"
                                @click="onImageClick(memorandumAssociationUrl)"
                            />
                        </div>
                    </div> -->
                    <!-- <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                    <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                        <div class="ant-col" style="padding: 12px;">
                            <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.memorandum-article') }}</h6>
                        </div>
                        <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                            <a-avatar
                                :size="74"
                                shape="square"
                                :src="memorandumArticleUrl"
                                @click="onImageClick(memorandumArticleUrl)"
                            />
                        </div>
                    </div> -->
                    <!-- <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                    <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                        <div class="ant-col" style="padding: 12px;">
                            <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.name-clearance-url-is') }}</h6>
                        </div>
                        <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                            <a-avatar
                                :size="74"
                                shape="square"
                                :src="nameClearanceUrl"
                                @click="onImageClick(nameClearanceUrl)"
                            />
                        </div>
                    </div> -->
                </div>

                <!-- <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.deed-url-is') }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <a-avatar
                            :size="74"
                            shape="square"
                            :src="deedUrl"
                            @click="onImageClick(deedUrl)"
                        />
                    </div>
                </div> -->


                <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ bankName }}</h6>
                        <h6 class="font-semibold text-md mb-10" >{{ bankBranch }}</h6>
                        <h6 class="font-semibold text-md mb-10" >{{ bankAccount }}</h6>
                        <h6 v-show="data.type == 'CONTRACTOR_GOODS'" class="font-semibold text-md mb-10" >{{ $t('form-label.bank-certificate') }}</h6>
                    </div>
                    <div v-show="data.type == 'CONTRACTOR_GOODS'" class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <!-- {{data}} -->
                        <a-avatar
                            v-if="data.solvencyCertificateUploadType == 'image'"
                            :size="74"
                            shape="square"
                            :src="bankCertificateUrl"
                            @click="onImageClick(bankCertificateUrl)"
                        />
                        <img
                            v-if="data.solvencyCertificateUploadType == 'pdf'"
                            :size="74"
                            style="height: 70px; width: 70px;cursor: pointer"
                            shape="square"
                            src="/images/pdf-image.png"
                            @click.prevent="onPdfModalShow(bankCertificateUrl)"
                        />
                    </div>
                </div>

                <hr  style="margin: 18px 0;border: none;height: 1px;background-color: #b4a8a8;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
                <!-- <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                    <div class="ant-col" style="padding: 12px;">
                        <h6 class="font-semibold text-md mb-10" >{{ $t('form-label.seal-scan-copy') }}</h6>
                    </div>
                    <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                        <a-avatar
                            :size="74"
                            shape="square"
                            :src="sealUrl"
                            @click="onImageClick(sealUrl)"
                        />
                    </div>
                </div> -->
            </a-card>
            <CoolLightBox 
                :items="images" 
                :index="index"
                @close="index = null">
            </CoolLightBox>
            <pdf-viewer-modal
                ref="pdfViewerModal"
            >
            </pdf-viewer-modal>
        </a-col>
    </section>
</template>

<script>
import { host } from "../../../../../api/config.js";
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

import PdfViewerModal from "../../modal/PdfViewerModal.vue";

export default {
    name: "Documents",
    components:{
        CoolLightBox,
        PdfViewerModal
    },
    props: {
        data:{
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            index: null,
        };
    },
    computed: {
        images() {
            let arr = [];
            let img = this.tinUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.binUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.tradeLicenseUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.realEstateMembershipUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.landDevelopersMembershipUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.incomeTaxUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.incorporationCertificateUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.memorandumAssociationUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.memorandumArticleUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.nameClearanceUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.deedUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.bankCertificateUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.sealUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            return arr;
        },
        
        tinNo(){
            if (this.data && this.data.tin){
                return this.$t('form-label.tin') + " : " + this.data.tin;
            }
            return this.$t('form-label.tin') + " : ";
        },
        bankName(){
           if (this.data && this.data.bankName){
                return this.$t('form-label.bank-name') + " : " + this.data.bankName;
            }
            return this.$t('form-label.bank-name') + " : "; 
        },
        bankBranch(){
            if (this.data && this.data.bankName){
                return this.$t('form-label.bank-branch') + " : " + this.data.bankBranch;
            }
            return this.$t('form-label.bank-branch') + " : "; 
        },
        bankAccount(){
            if (this.data && this.data.bankAccount){
                return this.$t('form-label.bank-a/c') + " : " + this.data.bankAccount;
            }
            return this.$t('form-label.bank-a/c') + " : "; 
        },
        binNo(){
            if (this.data && this.data.bin){
                return this.$t('form-label.bin') + " : " + this.data.bin;
            }
            return this.$t('form-label.bin') + " : ";
        },
        tradeLicenseNo(){
            if (this.data && this.data.tradeLicense){
                return this.$t('form-label.trade-license') + " : " + this.data.tradeLicense;
            }
            return this.$t('form-label.trade-license') + " : ";
        },

        realEstateMembershipNo(){
            if (this.data && this.data.realEstateMembership){
                return this.$t('form-label.real-estate-membership') + " : " + this.data.realEstateMembership;
            }
            return this.$t('form-label.real-estate-membership') + " : ";
        },
        landDevelopersMembershipNo(){
            if (this.data && this.data.landDevelopersMembership){
                return this.$t('form-label.land-developer-membership') + " : " + this.data.landDevelopersMembership;
            }
            return this.$t('form-label.land-developer-membership') + " : ";
        },

        tinUrl(){
             if (this.data && this.data.tinUrl && this.data.tinUrl.length > 0){
                return host + this.data.tinUrl;
            }
            return '/images/tin-default.png';
        },
        binUrl(){
             if (this.data && this.data.binUrl && this.data.binUrl.length > 0){
                return host + this.data.binUrl;
            }
            return '/images/vat-default.jpg';
        },
        tradeLicenseUrl(){
            if (this.data && this.data.tradeLicenseUrl && this.data.tradeLicenseUrl.length > 0){
                return host + this.data.tradeLicenseUrl;
            }
            return '/images/tradeLicense-default.jpg';
        },
        realEstateMembershipUrl(){
            if (this.data && this.data.realEstateMembershipUrl && this.data.realEstateMembershipUrl.length > 0){
                return host + this.data.realEstateMembershipUrl;
            }
            return '/images/certificate-default.jpg';
        },
        landDevelopersMembershipUrl(){
            if (this.data && this.data.landDevelopersMembershipUrl && this.data.landDevelopersMembershipUrl.length > 0){
                return host + this.data.landDevelopersMembershipUrl;
            }
            return '/images/certificate-default.jpg';
        },
        incomeTaxUrl(){
            if (this.data && this.data.incomeTaxUrl && this.data.incomeTaxUrl.length > 0){
                return host + this.data.incomeTaxUrl;
            }
            return '/images/certificate-default.jpg';
        },
        incorporationCertificateUrl(){
            if (this.data && this.data.incorporationCertificateUrl && this.data.incorporationCertificateUrl.length > 0){
                return host + this.data.incorporationCertificateUrl;
            }
            return '/images/certificate-default.jpg';
        },
        memorandumAssociationUrl(){
            if (this.data && this.data.memorandumUrl && this.data.memorandumUrl.length > 0){
                return host + this.data.memorandumUrl;
            }
            return '/images/certificate-default.jpg';
        },
        memorandumArticleUrl(){
            if (this.data && this.data.articleUrl && this.data.articleUrl.length > 0){
                return host + this.data.articleUrl;
            }
            return '/images/certificate-default.jpg';
        },
        nameClearanceUrl(){
            if (this.data && this.data.nameClearanceUrl && this.data.nameClearanceUrl.length > 0){
                return host + this.data.nameClearanceUrl;
            }
            return '/images/certificate-default.jpg';
        },
        deedUrl(){
            if (this.data && this.data.deedUrl && this.data.deedUrl.length > 0){
                return host + this.data.deedUrl;
            }
            return '/images/tradeLicense-default.jpg';
        },
        bankCertificateUrl(){
            if (this.data && this.data.solvencyCertificateUrl && this.data.solvencyCertificateUrl.length > 0){
                return host + this.data.solvencyCertificateUrl;
            }
            return '/images/tradeLicense-default.jpg';
        },
        sealUrl(){
            if (this.data && this.data.sealUrl && this.data.sealUrl.length > 0){
                return host + this.data.sealUrl;
            }
            return '/images/tradeLicense-default.jpg';
        },

        signatureUrl1(){
            if (this.data && this.data.signatureUrl1 && this.data.signatureUrl1.length > 0){
                return host + this.data.signatureUrl1;
            }
            return '';
        },
    },
    methods:{
        onImageClick(url) {
            let index = this.images.findIndex(e => e == url);
            if (index > -1) {
                this.index = index;
            }
        },
        onPdfModalShow(url){
            this.$refs.pdfViewerModal.showModal(url)
        }
    }
}
</script>

<style>

</style>